/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { fetchConfig, serializeForm } from "./global";

class ProductForm extends HTMLElement {
	constructor() {
		super();

		this.form = this.querySelector("form");
		this.formId = this.form?.id;
		this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
		this.cartNotification = document.querySelector("cart-notification");
		this.sizeErrorMessage = this.querySelector("[data-size-error]");
		this.boundDocumentChangeHandler = this.onDocumentChange.bind(this);
		document.addEventListener("change", this.boundDocumentChangeHandler);
	}

	handleCartItemInventory(itemID) {
		let isItemInCart = false;
		this.cartNotification.setActiveElement(document.activeElement);
		const submitButton = this.querySelector('[type="submit"]');

		fetch("/cart?view=mini")
			.then((response) => response.text())
			.then((html) => {
				const parser = new DOMParser();
				const cartContent = parser.parseFromString(html, "text/html");
				const quantityInputs = cartContent.querySelectorAll(".quantity__input");
				if (quantityInputs) {
					quantityInputs.forEach((quantityInput) => {
						if (quantityInput.dataset.variantId === itemID) {
							submitButton.setAttribute("disabled", true);
							submitButton.classList.add("loading");
							isItemInCart = true;

							const newItemQuantity = Number(quantityInput.value) + 1;
							fetch(`/cart/change?id=${itemID}&quantity=${newItemQuantity}`, {
								method: "post",
							})
								.then(() => {
									this.cartNotification.renderContents({
										itemID,
										itemQuantiy: quantityInput.value,
									});
									window.updateCartCount();
								})
								// eslint-disable-next-line no-console
								.catch((e) => console.error(e))
								.finally(() => {
									submitButton.classList.remove("loading");
									submitButton.removeAttribute("disabled");
								});
						}
					});

					if (!isItemInCart) {
						const body = JSON.stringify({
							...JSON.parse(serializeForm(this.form)),
							sections: this.cartNotification
								.getSectionsToRender()
								.map((section) => section.id),
							sections_url: window.location.pathname,
						});

						submitButton.setAttribute("disabled", true);
						submitButton.classList.add("loading");

						fetch(`${window.routes.cart_add_url}`, {
							...fetchConfig("javascript"),
							body,
						})
							.then((response) => response.json())
							.then(() => {
								this.cartNotification.renderContents();
								window.updateCartCount();
							})
							// eslint-disable-next-line no-console
							.catch((e) => console.error(e))
							.finally(() => {
								submitButton.classList.remove("loading");
								submitButton.removeAttribute("disabled");
							});
					}
				}
			})
			// eslint-disable-next-line no-console
			.catch((err) => console.warn("Something went wrong.", err));
	}

	onSubmitHandler(evt) {
		evt.preventDefault();

		if (!this.hasSelectedSize()) {
			this.showSizeError();
			return;
		}

		this.hideSizeError();
		const formData = JSON.parse(serializeForm(this.form));
		if (formData.id) {
			this.handleCartItemInventory(formData.id);
		}
	}

	hasSelectedSize() {
		const sizeInput = document.querySelector(
			'variant-radios input[name="Size"]',
		);
		if (!sizeInput) return true;

		return Boolean(
			document.querySelector('variant-radios input[name="Size"]:checked'),
		);
	}

	showSizeError() {
		if (!this.sizeErrorMessage) return;
		this.sizeErrorMessage.classList.remove("visually-hidden");
	}

	hideSizeError() {
		if (!this.sizeErrorMessage) return;
		this.sizeErrorMessage.classList.add("visually-hidden");
	}

	onDocumentChange(evt) {
		const { target } = evt;
		if (!target || target.name !== "Size" || !target.checked) return;

		if (
			target.form === this.form ||
			target.getAttribute("form") === this.formId
		) {
			this.hideSizeError();
		}
	}

	disconnectedCallback() {
		if (this.boundDocumentChangeHandler) {
			document.removeEventListener("change", this.boundDocumentChangeHandler);
		}
	}
}

customElements.get("product-form") ||
	customElements.define("product-form", ProductForm); // eslint-disable-line

const ModalDialog = customElements.get("modal-dialog");
class ProductModal extends ModalDialog {
	constructor() {
		// eslint-disable-line
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(
			`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`,
		).forEach((element) => {
			element.classList.remove("active");
		});
		const activeMedia = this.querySelector(
			`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
		);
		activeMedia.classList.add("active");
		activeMedia.scrollIntoView();

		if (
			activeMedia.nodeName === "DEFERRED-MEDIA" &&
			activeMedia.querySelector("template").content.querySelector(".js-youtube")
		)
			activeMedia.loadContent();
	}
}

customElements.get("product-modal") ||
	customElements.define("product-modal", ProductModal); // eslint-disable-line

const labels = document.querySelectorAll(
	".product-form__inputradio .radioselect",
);
const getSelectedSizeInput = () =>
	document.querySelector('variant-radios input[name="Size"]:checked');
const getWidthInputByButtonId = (buttonID) => {
	if (!buttonID) return null;

	const normalizedButtonID = buttonID.toLowerCase();
	const widthInputs = Array.from(
		document.querySelectorAll('variant-radios input[name="Width"]'),
	);
	return (
		widthInputs.find(
			(input) => input.value?.toLowerCase() === normalizedButtonID,
		) || null
	);
};

const setWidthInputByButtonId = (buttonID) => {
	const widthInput = getWidthInputByButtonId(buttonID);
	if (!widthInput) return null;
	widthInput.checked = true;
	return widthInput;
};

const clearSelectedSize = () => {
	document
		.querySelectorAll('variant-radios input[name="Size"]')
		.forEach((input) => {
			input.checked = false;
		});
};

const initializeWidthSelection = () => {
	const sizeFieldset = document.querySelector(
		".product-form-wrap__size fieldset",
	);
	const checkedWidthInput = document.querySelector(
		'variant-radios input[name="Width"]:checked',
	);
	const activeWidthLabel = document.querySelector(
		".product-form__inputradio .radioselect.active[data-button-id]",
	);
	const buttonID =
		activeWidthLabel?.dataset.buttonId ||
		checkedWidthInput?.value?.toLowerCase() ||
		sizeFieldset?.dataset.widthButton;
	if (!buttonID) return;
	if (sizeFieldset) sizeFieldset.setAttribute("data-width-button", buttonID);

	document
		.querySelectorAll(".product-form__inputradio .radioselect")
		.forEach((label) => {
			label.classList.toggle("active", label.dataset.buttonId === buttonID);
		});

	document
		.querySelectorAll(".product-form__inputdrawer label")
		.forEach((label) => {
			label.classList.toggle("active", label.dataset.buttonId === buttonID);
		});

	const drawerSwitch = document.querySelector(".switch--btn_drawer");
	if (drawerSwitch) drawerSwitch.setAttribute("data-button", buttonID);

	document.querySelectorAll(".sizes-info .accordion").forEach((element) => {
		element.classList.toggle("active", element.dataset.fit === buttonID);
	});
};

const escapeSelectorValue = (value) => {
	if (window.CSS && typeof window.CSS.escape === "function") {
		return window.CSS.escape(value);
	}

	return value.replace(/["\\]/g, "\\$&");
};

const selectedSizeByWidth = {};

const syncSelectedSizeByWidth = (widthType) => {
	const selectedSizeInput = getSelectedSizeInput();
	const widthInput = setWidthInputByButtonId(widthType);

	// Save current size for its width before switching
	if (selectedSizeInput) {
		const { widthType: currentWidth } = selectedSizeInput.dataset;
		if (currentWidth) {
			selectedSizeByWidth[currentWidth] = selectedSizeInput.value;
		}
	}

	if (!selectedSizeInput) {
		// No size was selected on the previous tab — restore saved size for target width
		const savedSize = selectedSizeByWidth[widthType];
		if (savedSize) {
			const savedInput = document.querySelector(
				`variant-radios input[name="Size"][data-width-type="${widthType}"][value="${escapeSelectorValue(savedSize)}"]`,
			);
			if (savedInput) {
				savedInput.checked = true;
				window.setTimeout(() => {
					savedInput.dispatchEvent(new Event("change", { bubbles: true }));
				}, 0);
				return;
			}
		}
		if (widthInput) {
			window.setTimeout(() => {
				widthInput.dispatchEvent(new Event("change", { bubbles: true }));
			}, 0);
		}
		return;
	}

	// A size was actively selected — carry it over if it exists in the target width
	const selectedSizeValue = selectedSizeInput.value;
	const matchingInput = document.querySelector(
		`variant-radios input[name="Size"][data-width-type="${widthType}"][value="${escapeSelectorValue(selectedSizeValue)}"]`,
	);
	if (!matchingInput) {
		clearSelectedSize();
		if (widthInput) {
			window.setTimeout(() => {
				widthInput.dispatchEvent(new Event("change", { bubbles: true }));
			}, 0);
		}
		return;
	}

	matchingInput.checked = true;
	window.setTimeout(() => {
		matchingInput.dispatchEvent(new Event("change", { bubbles: true }));
	}, 0);
};

const changeActive = (e) => {
	[...labels].forEach((label) => {
		label.classList.remove("active");
	});
	e.target.classList.add("active");
	const buttonID = e.target.getAttribute("data-button-id");
	setWidthInputByButtonId(buttonID);
	document
		.querySelector(".product-form-wrap__size fieldset")
		.setAttribute("data-width-button", buttonID);
	syncSelectedSizeByWidth(buttonID);

	// update size chart selector
	const sizeChartSelector = document.querySelector(
		`.product-form__inputdrawer .radioselect[data-button-id="${buttonID}"]`,
	);
	if (sizeChartSelector) {
		document
			.querySelectorAll(".product-form__inputdrawer label")
			.forEach((label) => {
				label.classList.remove("active");
			});
		document
			.querySelector(".switch--btn_drawer")
			.setAttribute("data-button", buttonID);
		sizeChartSelector.classList.add("active");
	}

	const activeDrawerLabel = document.querySelector(
		`.product-form__inputdrawer label[data-button-id="${buttonID}"]`,
	);
	if (activeDrawerLabel) activeDrawerLabel.click();
};

[...labels].forEach((e) => {
	e.addEventListener("click", changeActive);
});

document.addEventListener("DOMContentLoaded", initializeWidthSelection);

/*  switch regular/narrow sizecharts in drawer */
const drawerLabels = document.querySelectorAll(
	".product-form__inputdrawer label",
);
const changeActiveDrawer = (e) => {
	e.preventDefault();
	[...drawerLabels].forEach((label) => {
		label.classList.remove("active");
	});
	e.target.classList.add("active");
	const buttonDrawerId = e.target.getAttribute("data-button-id");
	document
		.querySelector(".switch--btn_drawer")
		.setAttribute("data-button", buttonDrawerId);

	document.querySelectorAll(".sizes-info .accordion").forEach((element) => {
		element.classList.remove("active");
		if (element.dataset.fit === buttonDrawerId) element.classList.add("active");
	});
};
[...drawerLabels].forEach((e) => {
	e.addEventListener("click", changeActiveDrawer);
});

const drawerButtonTrigger = (e) => {
	const openDrawer = document.querySelector(".product-info-drawer");
	document.body.classList.add("open-drawer");
	openDrawer.classList.add("active");
	if (e.target.classList.contains("sizes")) {
		document.querySelector(".sizes-info").classList.add("open");
		document.querySelector(".width-info").classList.remove("open");
		document.querySelector(".get-notified-info").classList.remove("open");
	} else if (e.target.classList.contains("get-notified")) {
		document.querySelector(".get-notified-info").classList.add("open");
		document.querySelector(".width-info").classList.remove("open");
		document.querySelector(".sizes-info").classList.remove("open");
	} else if (e.target.classList.contains("get-notified-mobile")) {
		openDrawer.classList.remove("active");
		document
			.querySelector(".product-info-drawer__mobile")
			.classList.add("active");
	} else {
		document.querySelector(".width-info").classList.add("open");
		document.querySelector(".sizes-info").classList.remove("open");
		document.querySelector(".get-notified-info").classList.remove("open");
	}

	const activeButton =
		document.querySelector(
			".product-form__inputradio .radioselect.active[data-button-id]",
		) ||
		document.querySelector(
			".product-form__inputdrawer label.active[data-button-id]",
		);
	if (activeButton) {
		const activeDrawerLabel = document.querySelector(
			`.product-form__inputdrawer label[data-button-id="${activeButton.dataset.buttonId}"]`,
		);
		if (activeDrawerLabel) activeDrawerLabel.click();
	}
};
const drawerButtons = document.querySelectorAll(".product-form__drawer");
[...drawerButtons].forEach((e) => {
	e.addEventListener("click", drawerButtonTrigger);
});

document
	.querySelector(".product-width-info__close")
	.addEventListener("click", () => {
		document.querySelector(".product-info-drawer").classList.remove("active");
		document.body.classList.remove("open-drawer");
	});
document
	.querySelector(".product-width-info-mobile__close")
	.addEventListener("click", () => {
		document
			.querySelector(".product-info-drawer__mobile")
			.classList.remove("active");
	});

function checkMobile(x) {
	try {
		if (x.matches) {
			document.getElementById("BIS_trigger").className = "get-notified-mobile";
		} else {
			document.getElementById("BIS_trigger").className = "get-notified";
		}
		// eslint-disable-next-line no-empty
	} catch (_error) {}
}

const x = window.matchMedia("(max-width: 700px)");
checkMobile(x);
x.addListener(checkMobile);

let scrollPos = 807;
function checkPosition() {
	const windowY = window.scrollY;
	if (windowY < scrollPos) {
		// scroll up code block
	} else {
		document.querySelector(".button-addtocart-sticky").classList.add("slideUp");
	}
	scrollPos = windowY;

	const element = document.querySelector("#ButtonAddToCart");
	const position = element.getBoundingClientRect();
	if (position.top < window.innerHeight && position.bottom >= 0) {
		document
			.querySelector(".button-addtocart-sticky")
			.classList.remove("slideUp");
	}
}

window.addEventListener("scroll", checkPosition);

document.addEventListener("DOMContentLoaded", () => {
	const productInfoDrawer = document.querySelector(
		".product-info-drawer.visually-hidden",
	);
	if (productInfoDrawer) {
		productInfoDrawer.classList.remove("visually-hidden");
	}
});
